import React, { useCallback } from "react";
import { Table } from "evergreen-ui";

const DataTableBody = ({ columns, data, onSelect }) => {
  const handleOnSelect = useCallback(
    (entry) => () => {
      onSelect(entry);
    },
    [onSelect]
  );
  return (
    <Table.Body>
      {data.map((entry) => (
        <Table.Row
          {...(onSelect && {
            isSelectable: true,
            onSelect: handleOnSelect(entry),
          })}
          className="row"
          key={`DataTable-Row-${entry.id}`}
        >
          {columns.map((column, columnIndex) => {
            const rowCellProps = {
              className: column.actions && "actions",
              flex: column.flex || "1",
              textAlign: column.align,
            };
            return (
              <Table.TextCell
                {...rowCellProps}
                key={`DataTable-Cell-${entry.id}-${columnIndex}`}
              >
                {column.render
                  ? column.render(entry)
                  : column.key && column.key in entry
                  ? entry[column.key]
                  : null}
              </Table.TextCell>
            );
          })}
        </Table.Row>
      ))}
    </Table.Body>
  );
};

export default DataTableBody;
